import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowBottomLeftCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareArrowBottomLeftCorner"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M12.5 17.5H6.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7 17L13 11" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareArrowBottomLeftCorner;
